var _defs, _path, _path2, _path3, _g, _path4, _g2, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewServiceConfGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 172.506,
    height: 140.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newServiceConfGraph_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h2v139H0z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 151",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    d: "M1 1l1 139"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 154",
    fill: "none",
    stroke: "red",
    strokeWidth: 2,
    d: "M116 1L65 87"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 153",
    fill: "none",
    stroke: "red",
    strokeWidth: 2,
    d: "M66 87H2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30EA\\u30D4\\u30FC\\u30C8\\u30B0\\u30EA\\u30C3\\u30C9 1",
    transform: "translate(64 1)",
    clipPath: "url(#newServiceConfGraph_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 156",
    fill: "rgba(0,0,0,0)",
    stroke: "#9e9e9e",
    strokeWidth: 2,
    d: "M1 0v3M1 5v3M1 10v3M1 15v3M1 20v3M1 25v3M1 30v3M1 35v3M1 40v3M1 45v3M1 50v3M1 55v3M1 60v3M1 65v3M1 70v3M1 75v3M1 80v3M1 85v3M1 90v3M1 95v3M1 100v3M1 105v3M1 110v3M1 115v3M1 120v3M1 125v3M1 130v3M1 135v3"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 155",
    fill: "none",
    stroke: "red",
    strokeWidth: 2,
    d: "M172 1h-57"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30EA\\u30D4\\u30FC\\u30C8\\u30B0\\u30EA\\u30C3\\u30C9 2",
    transform: "translate(115 1)",
    clipPath: "url(#newServiceConfGraph_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 156",
    fill: "rgba(0,0,0,0)",
    stroke: "#9e9e9e",
    strokeWidth: 2,
    d: "M1 0v3M1 5v3M1 10v3M1 15v3M1 20v3M1 25v3M1 30v3M1 35v3M1 40v3M1 45v3M1 50v3M1 55v3M1 60v3M1 65v3M1 70v3M1 75v3M1 80v3M1 85v3M1 90v3M1 95v3M1 100v3M1 105v3M1 110v3M1 115v3M1 120v3M1 125v3M1 130v3M1 135v3"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 154",
    fill: "none",
    stroke: "red",
    strokeWidth: 2,
    d: "M116 1L65 87"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 153",
    fill: "none",
    stroke: "red",
    strokeWidth: 2,
    d: "M66 87H2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 152",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    d: "M1 139.5l171.5-1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 155",
    fill: "none",
    stroke: "red",
    strokeWidth: 2,
    d: "M172 1h-57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewServiceConfGraph);
export default __webpack_public_path__ + "static/media/newServiceConfGraph.33b3ddee992b35e6.svg";
export { ForwardRef as ReactComponent };